<section>
  <div class="report-tab">
    <ul class="nav nav-pills" role="tablist">
      <li class="nav-item" role="presentation">
        <span class="nav-link active">Sell-Through Report</span>
      </li>
    </ul>
  </div>

  <!-- Report filter-->
  <div class="payment-report-filters d-flex flex-wrap gap-2 mt-3 mb-2">
    <div class="filter-wrapper">
      <div class="dropdown stores" style="width: unset !important">
        <div class="report-type" data-bs-toggle="dropdown">
          <small class="filter-text">{{ storeName }}</small>
          <button
            class="btn text-nowrap"
            type="button"
            id="dropdownMenuButton"
            aria-expanded="false"
          >
            <img src="assets/pos/products/ic_upDown.svg" />
          </button>
        </div>

        <div
          class="dropdown-menu p-2 mt-1"
          aria-labelledby="dropdownMenuButton"
          style="width: 100%"
        >
          <ul>
            <li style="border-bottom: 1px solid #d4d4d4">
              <a class="dropdown-item">
                <div class="form-check d-flex" style="cursor: pointer">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                    [checked]="headerCheckboxSelected"
                    (click)="toggleAllCheckboxes()"
                  />
                  <label class="form-check-label" for="flexCheckChecked">
                    Select all Stores ({{
                      stores.length ? (stores.length | number) : 0
                    }})
                  </label>
                </div>
              </a>
            </li>
            <li *ngFor="let str of stores; let i = index">
              <a class="dropdown-item">
                <div class="form-check d-flex" style="cursor: pointer">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                    [value]="str.storeId"
                    [checked]="headerCheckboxSelected"
                    [value]="str.isSelected"
                    (change)="setFilterNames(str, 2)"
                  />
                  <label class="form-check-label" for="flexCheckChecked">
                    {{ str.storeName }}
                  </label>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="filter-wrapper">
      <div class="dropdown">
        <div class="report-type" data-bs-toggle="dropdown">
          <small class="filter-text">{{ deptName }}</small>
          <button
            class="btn text-nowrap"
            type="button"
            id="dropdownMenuButton"
            aria-expanded="false"
          >
            <img src="assets/pos/products/ic_upDown.svg" />
          </button>
        </div>

        <div
          class="dropdown-menu p-2 mt-1"
          aria-labelledby="dropdownMenuButton"
          style="width: 13.5rem"
        >
          <ul>
            <li (click)="selectAllDepartments()">
              <a class="dropdown-item">All departments</a>
            </li>
            <li
              *ngFor="let dept of mainDepartmentList"
              (click)="
                setFilterNames(dept, 1);
                getCategoriesByDeptId(dept.departmentId)
              "
            >
              <a class="dropdown-item">{{ dept.departmentDescr }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="filter-wrapper" [ngClass]="{ disabled: disableCategory }">
      <div class="dropdown" style="width: unset !important">
        <div class="report-type" data-bs-toggle="dropdown">
          <small class="filter-text">{{ categoryName }}</small>
          <button
            class="btn text-nowrap"
            type="button"
            id="dropdownMenuButton"
            aria-expanded="false"
          >
            <img src="assets/pos/products/ic_upDown.svg" />
          </button>
        </div>

        <div
          class="dropdown-menu p-2 mt-1"
          aria-labelledby="dropdownMenuButton"
          style="width: 100%"
        >
          <ul>
            <li (click)="selectAllcategories()">
              <a class="dropdown-item">All Categories</a>
            </li>
            <li *ngFor="let ctg of categorieslist">
              <a class="dropdown-item" (click)="setFilterNames(ctg, 3)">{{
                ctg.categoryName
              }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--week color -->

    <div class="filter-wrapper" *ngIf="showWeekColor">
      <div class="dropdown stores" style="width: unset !important">
        <div class="report-type" data-bs-toggle="dropdown">
          <small class="filter-text">
            {{ weekColor }}
          </small>
          <button
            class="btn text-nowrap"
            type="button"
            id="dropdownMenuButton"
            aria-expanded="false"
          >
            <img src="assets/pos/products/ic_upDown.svg" />
          </button>
        </div>

        <div
          class="dropdown-menu p-2 mt-1"
          aria-labelledby="dropdownMenuButton"
          style="width: 100%"
        >
          <ul>
            <li (click)="selectAllcolors()">
              <a class="dropdown-item">All Week Colors</a>
            </li>
            <li
              *ngFor="let wk of weekColorsList"
              (click)="setFilterNames(wk, 5)"
            >
              <a class="dropdown-item" [style.backgroundColor]="wk.color">{{
                wk.displayName
              }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="filter-wrapper date-range"
      (click)="openCalender()"
      style="cursor: pointer"
    >
      <div class="dropdown mt-1" style="width: unset !important">
        <div
          class="report-type ps-0"
          style="width: 18rem"
        >
          <button
            class="btn text-nowrap"
            type="button"
            id="dropdownMenuButton"
            aria-expanded="false"
            style="
              border-top-right-radius: 0px;
              border-bottom-right-radius: 0px;
              border-right: 1px solid #d4d4d4;
              border-top-left-radius: 8px;
              border-bottom-left-radius: 8px;
            "
          >
            <img src="assets/pos/products/ic_leftArrow.svg" />
          </button>
          <input
            type="text"
            name="daterangeInput"
            daterangepicker
            #dateRange
            [options]="options"
            (selected)="selectedDate($event)"
            style="max-width: 17rem"
          />
          <button
            class="btn text-nowrap"
            type="button"
            id="dropdownMenuButton"
            aria-expanded="false"
          >
            <img src="assets/pos/products/ic_rightArrow.svg" />
          </button>
        </div>
      </div>
    </div>
    <div
      class="create-btn run-report-btn ms-2 c-pt"
      [class.is-loading]="isLoading"
      (click)="runReport()"
    >
      <span class="run-spinner" *ngIf="isLoading"></span>
      <img
        *ngIf="!isLoading"
        src="assets/Pos-Catalog/jam_refresh.svg"
        class="run-icon"
        alt=""
      />
      {{ isLoading ? "Running…" : "Run Report" }}
    </div>
  </div>

  <!-- empty state: shown until the report is run -->
  <div class="report-empty-state" *ngIf="!reportHasRun">
    <img src="assets/dashboard/noData.svg" alt="" />
    <h5>Ready when you are</h5>
    <p>
      Adjust the filters above, then click <strong>Run Report</strong> to
      generate the sell-through report.
    </p>
    <div class="create-btn run-report-btn c-pt" (click)="runReport()">
      <img src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
      Run Report
    </div>
  </div>

  <div
    *ngIf="reportHasRun"
    style="
      height: calc(100vh - 250px);
      overflow: auto;
      padding-bottom: 3rem;
      position: relative;
    "
    [ngStyle]="{ overflow: isLoading ? 'hidden' : 'auto' }"
  >
    <!--Report table-->

    <div class="no-table-report text-center mt-3" *ngIf="noDataFound">
      <div class="m-auto">
        <div class="img-container m-auto d-flex">
          <img src="assets/emp reports/ic_noTableData.svg" class="m-auto" />
        </div>

        <p style="color: #9e9e9e" class="mt-4">
          There is no report available yet. <br />
          Please check back later
        </p>
      </div>
    </div>

    <div class="report-table-wrapper mt-3" *ngIf="!noDataFound">
      <div class="report-dept-head mt-4">
        <p style="text-transform: uppercase">
          stores : {{ storeIds.length ? storeIds.length : "ALL" }} stores
          selected | {{ deptName }} / {{ categoryName }}
        </p>
      </div>

      <div class="inventory-report-table">
        <table class="table parent-table table-bordered mb-0">
          <thead style="box-shadow: unset">
            <tr class="font-bold-tr">
              <td class="p-0 sticky-cols">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <td style="border: unset !important; min-width: 17rem">
                        Store
                      </td>
                      <td class="boxShadow" style="width: 10rem">Producer</td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td class="py-0">
                <table class="table child-table nowrap mb-0">
                  <thead style="box-shadow: unset">
                    <tr>
                      <th
                        class="text-end measureHead"
                        *ngFor="
                          let col of OutOfStockColumnName;
                          let last = last
                        "
                        style="min-width: 9.68rem; white-space: nowrap"
                      >
                        {{ col.columnName }}
                      </th>
                    </tr>
                  </thead>
                  <tr></tr>
                </table>
              </td>
            </tr>
          </thead>
          <tbody *ngFor="let item of sellThroughData">
            <tr style="border: 1px solid #fff">
              <td class="p-0 sticky-cols" style="border: unset !important">
                <table class="table mb-0">
                  <tr>
                    <td
                      class="d-flex p-0"
                      style="
                        border: unset !important;
                        min-width: 17rem;
                        width: 17rem;
                        white-space: nowrap;
                      "
                    >
                      <img [src]="item.img" class="py-0" style="height: 2rem" />
                      <div
                        class="ms-1 p-0 d-flex"
                        (click)="toggleProducersData(item)"
                        style="cursor: pointer"
                      >
                        <div class="d-flex flex-column justify-content-center">
                          <img
                            src="assets/dashboard/ic_DropDownRight.svg"
                            class="me-2"
                            [ngClass]="{ rotateIcon: item.isProducersData }"
                            style="height: 10px; width: 6px"
                          />
                        </div>
                        <p class="d-flex flex-column justify-content-center">
                          {{ item.storeName }}
                        </p>
                      </div>
                    </td>
                    <td
                      class="p-0 boxShadow"
                      style="
                        min-width: 8rem !important;
                        border-bottom: 1px solid #fff;
                      "
                      *ngIf="item.isProducersData"
                    >
                      <table class="table mb-0">
                        <tr *ngFor="let prdcs of item.producers">
                          <td
                            class="d-flex"
                            style="
                              cursor: pointer;
                              white-space: nowrap;
                              color: #2196f3;
                              width: 10rem;
                            "
                            data-toggle="modal"
                            data-backdrop="static"
                            data-target="#deleteDataModal"
                            (click)="
                              populateProducerModalTable(prdcs, item.storeName)
                            "
                          >
                            <p
                              class="p-0 d-flex flex-column justify-content-center"
                              style="height: 2rem"
                            >
                              {{ prdcs.UserName }}
                            </p>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td
                      class="p-0 boxShadow"
                      style="
                        min-width: 8rem !important;
                        border-bottom: 1px solid #fff;
                      "
                      [ngClass]="{ 'hide-content': item.isProducersData }"
                    >
                      <table class="table mb-0">
                        <tr>
                          <td
                            class="d-flex"
                            style="
                              white-space: nowrap;
                              color: #2196f3;
                              width: 10rem;
                            "
                          >
                            <p
                              class="p-0 d-flex flex-column justify-content-center"
                              style="height: 2rem"
                            >
                              {{ item.producers.length | number }} Producers
                            </p>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>

              <td
                class="p-0"
                style="border: unset !important"
                [ngClass]="{ 'hide-content': !item.isProducersData }"
              >
                <table class="table child-table mb-0">
                  <tr style="border-bottom: 1px solid #fff">
                    <td
                      class="text-end p-0"
                      *ngFor="let OutletWiseData of item.measuredValues"
                      style="
                        padding-right: 0.5rem;
                        min-width: 9rem;
                        max-width: 9rem;
                        border-bottom: unset !important;
                      "
                    >
                      <table class="w-100">
                        <tbody>
                          <tr
                            *ngFor="
                              let val of OutletWiseData.data;
                              let last = last
                            "
                          >
                            <td style="min-width: 9rem; max-width: 9rem">
                              <ng-container
                                *ngIf="OutletWiseData.columnId !== 15"
                              >
                                <p
                                  style="height: 2rem"
                                  class="d-flex flex-column justify-content-center"
                                >
                                  <ng-container
                                    *ngIf="
                                      isNumber(val.value);
                                      else currencyTemplate
                                    "
                                  >
                                    {{ val.value | number }}
                                  </ng-container>
                                  <ng-template #currencyTemplate>
                                    {{ val.value }}
                                  </ng-template>
                                </p>
                              </ng-container>
                              <ng-container
                                *ngIf="OutletWiseData.columnId == 15"
                              >
                                <canvas
                                  [attr.id]="val.producerID"
                                  style="max-height: 2rem !important"
                                ></canvas>
                              </ng-container>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
              <td
                class="p-0"
                style="border: unset !important"
                [ngClass]="{ 'hide-content': item.isProducersData }"
              >
                <table class="table child-table mb-0">
                  <tr style="border-bottom: 1px solid #fff">
                    <td
                      class="text-end p-0"
                      style="
                        padding-right: 0.5rem;
                        min-width: 9rem;
                        max-width: 9rem;
                        border-bottom: unset !important;
                      "
                    >
                      <table class="w-100">
                        <tbody>
                          <tr>
                            <td
                              style="min-width: 9rem; max-width: 9rem"
                              *ngFor="let val of item.storeTotal"
                            >
                              <ng-container *ngIf="val.columnId !== 15">
                                <p
                                  style="height: 2rem"
                                  class="d-flex flex-column justify-content-center"
                                >
                                  <ng-container
                                    *ngIf="
                                      isNumber(val.total);
                                      else currencyTemplate
                                    "
                                  >
                                    {{ val.total | number }}
                                  </ng-container>
                                  <ng-template #currencyTemplate>
                                    {{ val.total }}
                                  </ng-template>
                                </p>
                              </ng-container>
                              <ng-container *ngIf="val.columnId == 15">
                                <canvas
                                  [attr.id]="item.storeID"
                                  style="max-height: 2rem !important"
                                ></canvas>
                              </ng-container>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr
              style="background: #f5f5f5"
              [ngClass]="{ 'hide-content': !item.isProducersData }"
            >
              <td class="p-0 sticky-cols sticky-cols">
                <table class="table mb-0">
                  <tr>
                    <td
                      style="
                        border: unset !important;
                        min-width: 17rem;
                        width: 17rem;
                        white-space: nowrap;
                      "
                    >
                      <p style="font-weight: 500" class="ps-3">Store Total</p>
                    </td>
                    <td
                      class="boxShadow"
                      style="white-space: nowrap; color: #2196f3; width: 10rem"
                    >
                      {{ item.producers.length | number }} Producers
                    </td>
                  </tr>
                </table>
              </td>

              <td class="p-0" style="border: unset !important">
                <table class="table mb-0">
                  <tr style="border-bottom: 1px solid #f5f5f5">
                    <td
                      class="text-end p-0"
                      style="
                        padding-right: 0.5rem;
                        min-width: 9rem;
                        max-width: 9rem;
                        border-bottom: unset !important;
                      "
                    >
                      <table class="w-100 mb-0">
                        <tbody>
                          <tr>
                            <td
                              style="min-width: 9rem; max-width: 9rem"
                              *ngFor="
                                let val of item.storeTotal;
                                let last = last
                              "
                            >
                              <ng-container *ngIf="val.columnId !== 15">
                                <p
                                  style="height: 2rem"
                                  class="d-flex flex-column justify-content-center"
                                >
                                  <ng-container
                                    *ngIf="
                                      isNumber(val.total);
                                      else currencyTemplate
                                    "
                                  >
                                    {{ val.total | number }}
                                  </ng-container>
                                  <ng-template #currencyTemplate>
                                    {{ val.total }}
                                  </ng-template>
                                </p>
                              </ng-container>
                              <ng-container *ngIf="val.columnId == 15">
                                -
                              </ng-container>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="grandTotal && grandTotal.length">
            <tr style="font-weight: bold">
              <td class="p-0 sticky-cols" style="border: unset !important">
                <table class="table mb-0">
                  <tr>
                    <td
                      style="
                        border: unset !important;
                        min-width: 17rem;
                        width: 17rem;
                        white-space: nowrap;
                      "
                    >
                      <p style="font-weight: bold" class="ps-3">Total</p>
                    </td>
                    <td class="boxShadow" style="width: 10rem"></td>
                  </tr>
                </table>
              </td>
              <td class="p-0" style="border: unset !important">
                <table class="table mb-0">
                  <tr style="border-bottom: 1px solid #fff">
                    <td
                      class="text-end p-0"
                      style="
                        padding-right: 0.5rem;
                        min-width: 9rem;
                        max-width: 9rem;
                        border-bottom: unset !important;
                      "
                    >
                      <table class="w-100 mb-0">
                        <tbody>
                          <tr>
                            <td
                              style="min-width: 9rem; max-width: 9rem"
                              *ngFor="let val of grandTotal"
                            >
                              <ng-container *ngIf="val.columnId !== 15">
                                <p
                                  style="height: 2rem"
                                  class="d-flex flex-column justify-content-center"
                                >
                                  <ng-container
                                    *ngIf="
                                      isNumber(val.total);
                                      else currencyTemplate
                                    "
                                  >
                                    {{ val.total | number }}
                                  </ng-container>
                                  <ng-template #currencyTemplate>
                                    {{ val.total }}
                                  </ng-template>
                                </p>
                              </ng-container>
                              <ng-container *ngIf="val.columnId == 15">
                                <p
                                  style="height: 2rem"
                                  class="d-flex flex-column justify-content-center"
                                >-</p>
                              </ng-container>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--Report chart -->
    <div class="chart-section mt-4">
      <div>
        <div class="d-flex justify-content-between head-container">
          <small style="font-weight: 600">Sell-through Rate </small>
          <div class="d-flex filter-container">
            <div id="filter-border" class="me-4">|</div>
            <div class="d-flex me-3">
              <div
                class="me-1"
                style="
                  height: 6px;
                  width: 6px;
                  border-radius: 50%;
                  background: #66bb6a;
                  margin: auto;
                "
              ></div>
              <small
                style="font-size: 12px"
                class="d-flex flex-column justify-content-center"
                >Sell-through Rate</small
              >
            </div>

            <div class="sell-chart-filters d-flex">
              <div class="filter-wrapper me-3">
                <div class="dropdown" style="width: unset !important">
                  <div class="report-type" data-bs-toggle="dropdown">
                    <small class="filter-text">{{ chartStoreName }}</small>
                    <button
                      class="btn text-nowrap"
                      type="button"
                      id="dropdownMenuButton"
                      aria-expanded="false"
                    >
                      <img src="assets/dashboard/ic_DropDown.svg" />
                    </button>
                  </div>

                  <div
                    class="dropdown-menu p-2 mt-1"
                    aria-labelledby="dropdownMenuButton"
                    style="width: 13.5rem"
                  >
                    <ul>
                      <li
                        *ngFor="let str of stores"
                        (click)="
                          getUsersByStore(str.storeId);
                          setSellThroughChartParameters(str, 1)
                        "
                      >
                        <a class="dropdown-item">{{ str.storeName }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="filter-wrapper me-3">
                <div class="dropdown" style="width: unset !important">
                  <div class="report-type" data-bs-toggle="dropdown">
                    <small class="filter-text">{{ chartUserName }}</small>
                    <button
                      class="btn text-nowrap"
                      type="button"
                      id="dropdownMenuButton"
                      aria-expanded="false"
                    >
                      <img src="assets/dashboard/ic_DropDown.svg" />
                    </button>
                  </div>

                  <div
                    class="dropdown-menu p-2 mt-1"
                    aria-labelledby="dropdownMenuButton"
                    style="width: 13.5rem"
                  >
                    <ul>
                      <li (click)="setOverAllOption()">
                        <a class="dropdown-item">Over All</a>
                      </li>
                      <li
                        *ngFor="let item of usersArray"
                        (click)="setSellThroughChartParameters(item, 2)"
                      >
                        <a class="dropdown-item">{{ item.UserName }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3" *ngIf="!noChartData">
          <canvas
            id="salesStatisticsV3"
            style="max-height: 14.25rem !important"
          ></canvas>
        </div>
      </div>

      <div *ngIf="noChartData" class="no-chart-data">
        <div class="m-auto">
          <div class="img-container m-auto d-flex">
            <img src="assets/emp reports/ic_noTableData.svg" class="m-auto" />
          </div>

          <p style="color: #9e9e9e" class="mt-3">
            There is no report available yet. <br />
            Please check back later
          </p>
        </div>
      </div>
    </div>

    <!--  report producers table-->
    <div class="report-product-wrapper mt-4">
      <h6>Top Producers</h6>

      <div class="no-table-report text-center mt-3" *ngIf="noDataFound">
        <div class="m-auto">
          <div class="img-container m-auto d-flex">
            <img src="assets/emp reports/ic_noTableData.svg" class="m-auto" />
          </div>

          <p style="color: #9e9e9e" class="mt-4">
            There is no report available yet. <br />
            Please check back later
          </p>
        </div>
      </div>

      <div class="report-product-table mt-3" *ngIf="!noDataFound">
        <table class="table mb-0">
          <thead class="parent-thead">
            <tr>
              <th width="30%">Store</th>
              <th width="15%">Producer</th>
              <th class="p-0" width="55%">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th
                        style="min-width: 9.82rem; white-space: nowrap"
                        class="text-end"
                        *ngFor="let item of producersColumns"
                      >
                        {{ item.columnName }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of empTableData">
              <td class="pb-0">
                {{ item.storeName }}
              </td>
              <td class="d-flex pb-0" style="border: unset !important">
                <div class="ms-3">
                  <p style="color: #2196f3" class="mt-2">
                    {{ item.UserName }}
                  </p>
                </div>
              </td>
              <td style="border: unset !important" class="p-0">
                <table class="table w-100 tbl-child mb-0">
                  <tr style="border: unset !important">
                    <td
                      *ngFor="let data of item.prdData"
                      class="text-end"
                      style="min-width: 9.82rem; white-space: nowrap"
                    >
                      <ng-container *ngIf="data.columnID !== 7">
                        <p
                          style="height: 2rem"
                          class="d-flex flex-column justify-content-center"
                        >
                          <ng-container
                            *ngIf="isNumber(data.value); else currencyTemplate"
                          >
                            {{ data.value | number }}
                          </ng-container>
                          <ng-template #currencyTemplate>
                            {{ data.value }}
                          </ng-template>
                        </p>
                      </ng-container>
                      <ng-container *ngIf="data.columnID == 7">
                        <canvas
                          [attr.id]="data.value.producerID"
                          style="
                            max-height: 2rem !important;
                            min-width: 9.82rem;
                            max-width: 9.82rem;
                          "
                        ></canvas>
                      </ng-container>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--loader-->
    <div class="overlay" *ngIf="isLoading">
      <div class="loader"></div>
    </div>
  </div>

  <!--Boostrap modal for producers expanded view -->
  <div
    class="modal fade"
    id="deleteDataModal"
    aria-hidden="true"
    aria-labelledby="exampleModalToggleLabel"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="report-table-wrapper">
          <div
            class="report-dept-head px-4 d-flex justify-content-between"
            style="border-radius: 0px"
          >
            <p>STORE : {{ modalStoreName }} | Producer : {{ modalUserName }}</p>
            <p data-dismiss="modal" aria-label="Close" style="cursor: pointer">
              Close X
            </p>
          </div>

          <div class="inventory-report-table">
            <table class="table parent-table table-bordered mb-0">
              <thead class="" style="box-shadow: unset !important">
                <tr class="font-bold-tr">
                  <td class="p-0 sticky-cols">
                    <table class="table mb-0">
                      <tbody>
                        <tr>
                          <th
                            style="border: unset !important; min-width: 17rem"
                          >
                            Department
                          </th>
                          <th
                            class="px-0 boxShadow"
                            style="border: unset !important; width: 10rem"
                          >
                            Category
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  <td class="py-0">
                    <table class="table child-table nowrap mb-0">
                      <thead style="box-shadow: unset !important">
                        <tr>
                          <th
                            class="text-end measureHead"
                            *ngFor="let col of modalColumns; let last = last"
                            style="min-width: 9.68rem; white-space: nowrap"
                          >
                            {{ col.columnName }}
                          </th>
                        </tr>
                      </thead>
                      <tr></tr>
                    </table>
                  </td>
                </tr>
              </thead>
              <tbody *ngFor="let item of sellThroughDeptTableData">
                <tr style="border: 1px solid #fff">
                  <td class="sticky-cols p-0" style="border: unset !important">
                    <table class="table mb-0">
                      <tr>
                        <td
                          class="d-flex p-0 sticky-cols"
                          style="
                            border: unset !important;
                            min-width: 17rem;
                            width: 17rem;
                            white-space: nowrap;
                          "
                        >
                          <div
                            class="ps-2 p-0 d-flex"
                            (click)="toggleCategoryData(item)"
                            style="cursor: pointer"
                          >
                            <img
                              src="assets/dashboard/ic_DropDownRight.svg"
                              class="me-2"
                              [ngClass]="{ rotateIcon: item.isCategoryData }"
                            />
                            <p
                              class="d-flex flex-column justify-content-center"
                            >
                              {{ item.deptName }}
                            </p>
                          </div>
                        </td>
                        <td
                          class="p-0"
                          style="
                            min-width: 8rem !important;
                            border-bottom: 1px solid #fff;
                          "
                          *ngIf="item.isCategoryData"
                        >
                          <table class="table mb-0">
                            <tr *ngFor="let ctg of item.categories">
                              <td
                                class="d-flex boxShadow"
                                style="
                                  cursor: pointer;
                                  white-space: nowrap;
                                  color: #2196f3;
                                  width: 10rem;
                                "
                              >
                                <p
                                  class="p-0 d-flex flex-column justify-content-center"
                                  style="height: 2rem"
                                >
                                  {{ ctg.CategoryName }}
                                </p>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td
                          class="p-0"
                          style="
                            min-width: 8rem !important;
                            border-bottom: 1px solid #fff;
                          "
                          *ngIf="!item.isCategoryData"
                        >
                          <table class="table mb-0">
                            <tr>
                              <td
                                class="d-flex boxShadow"
                                style="
                                  white-space: nowrap;
                                  color: #2196f3;
                                  width: 10rem;
                                "
                              >
                                <p
                                  class="p-0 d-flex flex-column justify-content-center"
                                  style="height: 2rem"
                                >
                                  {{ item.categories.length | number }}
                                  Categories
                                </p>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>

                  <td
                    class="p-0"
                    style="border: unset !important"
                    *ngIf="item.isCategoryData"
                  >
                    <table class="table child-table mb-0">
                      <tr style="border-bottom: 1px solid #fff">
                        <td
                          class="text-end p-0"
                          *ngFor="let OutletWiseData of item.measuredValues"
                          style="
                            padding-right: 0.5rem;
                            min-width: 9rem;
                            max-width: 9rem;
                            border-bottom: unset !important;
                          "
                        >
                          <table class="w-100">
                            <tbody>
                              <tr
                                *ngFor="
                                  let val of OutletWiseData.data;
                                  let last = last
                                "
                              >
                                <td style="min-width: 9rem; max-width: 9rem">
                                  <p
                                    style="height: 2rem"
                                    class="d-flex flex-column justify-content-center"
                                  >
                                    <ng-container
                                      *ngIf="
                                        isNumber(val.value);
                                        else currencyTemplate
                                      "
                                    >
                                      {{ val.value | number }}
                                    </ng-container>
                                    <ng-template #currencyTemplate>
                                      {{ val.value }}
                                    </ng-template>
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td
                    class="p-0"
                    style="border: unset !important"
                    *ngIf="!item.isCategoryData"
                  >
                    <table class="table child-table mb-0">
                      <tr style="border-bottom: 1px solid #fff">
                        <td
                          class="text-end p-0"
                          style="
                            padding-right: 0.5rem;
                            min-width: 9rem;
                            max-width: 9rem;
                            border-bottom: unset !important;
                          "
                        >
                          <table class="w-100">
                            <tbody>
                              <tr>
                                <td
                                  style="min-width: 9rem; max-width: 9rem"
                                  *ngFor="let val of item.deptTotal"
                                >
                                  <p
                                    style="height: 2rem"
                                    class="d-flex flex-column justify-content-center"
                                  >
                                    <ng-container
                                      *ngIf="
                                        isNumber(val.value);
                                        else currencyTemplate
                                      "
                                    >
                                      {{ val.value | number }}
                                    </ng-container>
                                    <ng-template #currencyTemplate>
                                      {{ val.total }}
                                    </ng-template>
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr style="background: #f5f5f5" *ngIf="item.isCategoryData">
                  <td class="p-0 sticky-cols">
                    <table class="table mb-0">
                      <tr>
                        <td
                          style="
                            border: unset !important;
                            min-width: 17rem;
                            width: 17rem;
                            white-space: nowrap;
                          "
                        >
                          <p style="font-weight: 500" class="ps-3">
                            Department Total
                          </p>
                        </td>
                        <td
                          class="boxShadow"
                          style="
                            white-space: nowrap;
                            color: #2196f3;
                            width: 10rem;
                          "
                        >
                          {{ item.categories.length | number }} Categories
                        </td>
                      </tr>
                    </table>
                  </td>

                  <td class="p-0" style="border: unset !important">
                    <table class="table mb-0">
                      <tr style="border-bottom: 1px solid #f5f5f5">
                        <td
                          class="text-end p-0"
                          style="
                            padding-right: 0.5rem;
                            min-width: 9rem;
                            max-width: 9rem;
                            border-bottom: unset !important;
                          "
                        >
                          <table class="w-100 mb-0">
                            <tbody>
                              <tr>
                                <td
                                  style="min-width: 9rem; max-width: 9rem"
                                  *ngFor="let val of item.deptTotal"
                                >
                                  <p
                                    style="height: 2rem"
                                    class="d-flex flex-column justify-content-center"
                                  >
                                    <ng-container
                                      *ngIf="
                                        isNumber(val.total);
                                        else currencyTemplate
                                      "
                                    >
                                      {{ val.total | number }}
                                    </ng-container>
                                    <ng-template #currencyTemplate>
                                      {{ val.total }}
                                    </ng-template>
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
